import { combineReducers } from '@reduxjs/toolkit';

import send from './send';
import isReadingMessages from './isReadingMessages';
import isLoadingMessages from './isLoadingMessages';
import isLoadingNextMessages from './isLoadingNextMessages';
import receivedMessageAt from './receivedMessageAt';
import displayedMessagesIds from './displayedMessagesIds';
import getNextMessagesUrl from './getNextMessagesUrl';

/**
 * @typedef {{
 *  send: import('./send').SendState,
 *  displayedMessagesIds: import('./displayedMessagesIds').DisplayedMessagesState,
 *  isReadingMessages: import('./isReadingMessages').IsReadingMessagesState,
 *  isLoadingMessages: import('./isLoadingMessages').IsLoadingMessagesState,
 *  isLoadingNextMessages: import('./isLoadingNextMessages').IsLoadingNextMessagesState,
 *  receivedMessageAt: import('./receivedMessageAt').ReceivedMessageAtState,
 *  getNextMessagesUrl: import('./getNextMessagesUrl').GetNextMessagesUrlState,
 * }} UIState
 */

export default combineReducers({
  send,
  displayedMessagesIds,
  isReadingMessages,
  isLoadingMessages,
  isLoadingNextMessages,
  receivedMessageAt,
  getNextMessagesUrl,
});
